import { Component, OnInit, ViewChild } from "@angular/core";
import { Accomplishment } from "src/app/model/accomplishment.dataContract";
import { MatTableDataSource, MatSort, MatPaginator } from "@angular/material";
import { SharedService } from "src/app/service/shared.service";

@Component({
  selector: "app-achievement",
  templateUrl: "./achievement.component.html",
  styleUrls: ["./achievement.component.css"],
})
export class AchievementComponent implements OnInit {
  accomplishmentList: Array<Accomplishment>;
  DarkMode: boolean;
  dataSource: MatTableDataSource<Accomplishment>;
  displayedColumns: string[] = ["view", "course", "organization"];

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(public sharedService: SharedService) {}

  ngOnInit(): void {
    this.DarkMode = this.sharedService.darkmode;
    this.accomplishmentList = new Array<Accomplishment>();
    this.accomplishmentList = [
      {
        course: "Introduction to Big Data",
        organization: "University of California San Diego",
        validity: "",
        certificateUrl:
          "https://www.coursera.org/account/accomplishments/certificate/TJN4QCHUDXS8",
      },

      {
        course:
          "Programming Mobile Applications for Android Handheld Systems: Part 2",
        organization: "University of Maryland, College Park",
        validity: "",
        certificateUrl:
          "https://www.coursera.org/account/accomplishments/records/G2628T887GVE",
      },
      {
        course: "Interactivity with JavaScript",
        organization: "University of Michigan",
        validity: "",
        certificateUrl:
          "https://www.coursera.org/account/accomplishments/certificate/8J8SPPAHBV2K",
      },
      {
        course: "Advanced Styling with Responsive Design",
        organization: "University of Michigan",
        validity: "",
        certificateUrl:
          "https://www.coursera.org/account/accomplishments/certificate/4ZNV5FZELC6W",
      },
      {
        course: "Front-End JavaScript Frameworks: Angular",
        organization: "The Hong Kong University of Science and Technology",
        validity: "",
        certificateUrl:
          "https://www.coursera.org/account/accomplishments/certificate/2TRKGH47WJKG",
      },
      {
        course: "Introduction to HTML5",
        organization: "University of Michigan",
        validity: "",
        certificateUrl:
          "https://www.coursera.org/account/accomplishments/certificate/JLWGF69G9AWF",
      },
      {
        course: "Using Databases with Python",
        organization: "University of Michigan",
        validity: "",
        certificateUrl:
          "https://www.coursera.org/account/accomplishments/certificate/MSLE5WMYSDDT",
      },
      {
        course: "Introduction to CSS3",
        organization: "University of Michigan",
        validity: "",
        certificateUrl:
          "https://www.coursera.org/account/accomplishments/certificate/PT8KW4XGFTT8",
      },
      {
        course:
          "Programming Mobile Applications for Android Handheld Systems: Part 1",
        organization: "University of Maryland, College Park",
        validity: "",
        certificateUrl:
          "https://www.coursera.org/account/accomplishments/certificate/JVFNZDA9NEGF",
      },
      {
        course: "Python Data Structures",
        organization: "University of Michigan",
        validity: "",
        certificateUrl:
          "https://www.coursera.org/account/accomplishments/certificate/QVBC5GTRN9U8",
      },
      {
        course: "Programming for Everybody (Python)",
        organization: "University of Michigan",
        validity: "",
        certificateUrl:
          "https://www.coursera.org/api/legacyCertificates.v1/spark/statementOfAccomplishment/972505~4261858/pdf",
      },
      {
        course: "An Introduction to Interactive Programming in Python (Part 1)",
        organization: "Rice University",
        validity: "",
        certificateUrl: "",
      },
      {
        course: "Introduction to Linux",
        organization: "The Linux Foundation",
        validity: "",
        certificateUrl:
          "https://s3.amazonaws.com/verify.edx.org/downloads/0bbe720cbcdd40bbbfccd283f921aa41/Certificate.pdf",
      },
      {
        course: " Introduction to C++",
        organization: "Microsoft Corporation",
        validity: "",
        certificateUrl:
          "https://courses.edx.org/certificates/e8411d48ce3f42dd8292a75d2364392d",
      },
      {
        course: "Introduction to Java Programming - Part 1",
        organization: "The Hong Kong University of Science and Technology",
        validity: "",
        certificateUrl:
          "https://courses.edx.org/certificates/867d49fe757b4a9fac4fc83c7a52754e",
      },
      {
        course: "IBM",
        organization: "Hadoop Foundation",
        validity: "",
        certificateUrl:
          "https://www.youracclaim.com/badges/0da085b7-e8b1-4f2f-96e7-3cb6743aee6f",
      },
    ];

    this.dataSource = new MatTableDataSource(this.accomplishmentList);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}
